import React, {Suspense} from 'react';
import extract from '../../utils/extractUrlParams';
import {Preloader} from '@ab/components';

const Main = React.lazy(() => import(/* webpackChunkName: "Settings" */ './views/main.c'));

const Settings = props => {
    let {match = {}} = props;

    return (
        <Suspense fallback={<Preloader className="center" />}>
            <Main
                {...props}
                action={match.params && match.params.action}
                params={extract(match.params && match.params.json)}
            />
        </Suspense>
    );
};

export default Settings;
